import useTranslator from "../../hooks/useTranslator";
import SkorProtectShield from "../../assets/img/skor-protect-shield.png";

const SkorProtectActivatedPopup = ({ show, onDone }) => {
  const { _t } = useTranslator();

  if (!show) return null;

  return (
    <div
      className="popup-overlay fixed inset-0 d-flex align-items-center justify-content-center z-50 wrapper-modal"
      style={{ zIndex: 9999 }}
    >
      <div className="sp-activated-card">
        <img src={SkorProtectShield} alt="" className="sp-activated-shield" />
        <h2 className="sp-activated-heading">{_t("skorProtectIsNowActive")}</h2>
        <p className="sp-activated-subheading">
          {_t("skorProtectIsNowActiveSubtitle")}
        </p>
        <button className="sp-activated-btn-done" onClick={onDone}>
          {_t("done")}
        </button>
      </div>
    </div>
  );
};

export default SkorProtectActivatedPopup;
